import type { ReactNode } from 'react';

import type { RouterLinkProps } from '@/utilities/redux-first-router.export';

import type { Portfolio } from '@/hooks/portfolio/usePortfolio';

import { DropdownItem } from './styled';

export type PortfolioDropdownItemValue = Portfolio['id'] | 'new';

type Props = {
  value: PortfolioDropdownItemValue;
  isSelected?: boolean;
  onBlur?: () => void;
  onClick?: () => void;
  onFocus?: () => void;
  onSelect?: (value: PortfolioDropdownItemValue) => void;
  onTouchEnd?: (yPos: number, id: string) => void;
  'data-cy-id'?: string;
  children: ReactNode;
  to: RouterLinkProps['to'];
};

export const PortfolioDropdownItem = ({
  to,
  value,
  onBlur,
  onFocus,
  onClick,
  onSelect,
  onTouchEnd,
  children,
  isSelected = false,
  'data-cy-id': dataCyId,
}: Props) => {
  return (
    <DropdownItem
      data-cy-id={dataCyId}
      to={to}
      tabIndex={-1}
      $isSelected={isSelected}
      onBlur={onBlur}
      onFocus={onFocus}
      onClick={() => {
        onSelect?.(value);
        onClick?.();
      }}
      onTouchEnd={(e) => {
        e.preventDefault();
        onTouchEnd?.(e.changedTouches[0].pageY, value);
      }}
    >
      {children}
    </DropdownItem>
  );
};
